<template>
    <div class="container">
        <!-- <span >跳转中...</span> -->
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 33%; /*display: flex; flex-direction: column; align-items: stretch;*/ text-align: center; height: 100%; background-color: #fff; 
        overflow: auto;font-size: 28px;
    }
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                unionCompany: JSON.parse(localStorage.dw_erp_union_company),
                companyItem:{},
            }
        },
        created() {
                this.get_url()
        },
        methods:{
            get_url(){
                var data = {};
                var src = top.location.href;
                var index = src.indexOf("?");
                if(index==-1){
                    return data;
                }
                var dataStr = src.substring(src.indexOf("?")+1); 
                var dataArray = dataStr.split("&");
                dataStr = "";
                for(var i=0;i<dataArray.length;i++){
                    var param = dataArray[i].split("=");
                    dataStr += ",'"+param[0]+"':'"+param[1]+"'";
                }
                if(dataStr.length>0){
                    dataStr = dataStr.substring(1);
                }
                dataStr = "{"+dataStr+"}";
                data = eval("("+dataStr+")");
                localStorage.setItem("dw_erp_user_token",data.token);
                this.postFunc("erp/cross.login",{},response=>{
                    // setTimeout(()=>{
                    this.setLocalStorge(response)
                    // },5000)
                        // top.location.replace("https://"+data.domain+".mix-test.dwood365.com/index")
                },error=>{
                    this.tip(error.data.message,"warning")
                });
            }
        },
    }
</script>
